import React, { useState } from 'react';
import { Observer } from 'mobx-react';
import styled from '@emotion/styled';
import {
  Button,
  MenuItem,
  Typography,
  Snackbar,
  IconButton,
  Menu,
} from '@material-ui/core';
import { css } from '@emotion/core';
import { Formik } from 'formik';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import ZipLink from './csv/ZipLink';
import { useRootStore } from '../../stores/BridgeProvider';
import SimpleSelect from '../util/SimpleSelect';
import { COLORS } from '../util/Colors';
import CustomMenu from '../common/CustomMenu';

const SnackbarStyle = css`
  .MuiTypography-root {
    background-color: #d32f30 !important;
  }
  #client-snackbar {
    display: flex;
    // align-items: center;
    flex-direction: column;
  }

  .errorIcon {
    font-size: 20;
    opacity: 0.9;
    margin-right: 10px;
  }

  .generic-error-section {
    display: flex;
    align-items: center;
  }

  .error-bullet {
    display: block;
  }
`;

const ButtonContainerStyle = css`
  display: flex;
  // flex-direction: column;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  margin: 5px 5px;
  button,
  .MuiInputBase-root {
    margin: 5px 5px;
    color: #666;
  }
  button {
    // margin-top: 12px;
    height: 42px;
  }
  .MuiSelect-select {
    padding: 12px !important;
  }
  .flexApartContainer {
    flex: 1;
    display: flex;
    // flex-direction: column;
    flex-direction: row;
    justify-content: space-between;
  }
  .rightButtonContainer {
    display: flex;
    align-items: center;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 200px;
`;

const Drawer = css`
  // width: 240px;
  box-sizing: border-box;
  width: 100%;
  height: 80px;
  bottom: 0px;
  position: fixed;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  // flex-direction: column;
  flex-direction: row;
  align-items: center;
  padding: 0.7rem 5px;
  padding-top: 1rem;
  z-index: 800;
  color: #666;
  // .MuiSnackbar-root {
  //   left: calc(50% + 125px) !important;
  // }
`;

const ViewCentricity = [
  {
    type: 'Deal Centric',
    val: {
      dealCentric: true,
    },
  },
  {
    type: 'Voucher Centric',
    val: {
      voucherCentric: true,
    },
  },
  {
    type: 'Open View',
    val: {
      dealCentric: false,
      voucherCentric: false,
    },
  },
];

const DealMapperDrawer = () => (
  <Observer
    render={() => {
      const { dealMapperStore, dataStore } = useRootStore();
      const [showInvalidModal, setShowInvalidModal] = useState(false);
      const [errorList, setErrorList] = useState([]);
      const [anchorEl, setAnchorEl] = useState(null);

      const handleMenuClick = event => {
        setAnchorEl(event.currentTarget);
      };

      const handleMenuClose = () => {
        setAnchorEl(null);
      };
      const initialCentricity = () => {
        const {
          dealMapperViewStore: { dealCentric, voucherCentric },
        } = dealMapperStore;
        if (dealCentric) return 0;
        if (voucherCentric) return 1;
        return 2;
      };
      // <Typography variant="h4" style={{ marginBottom: '0rem' }}>
      //   Deal Mapper
      // </Typography>;
      const csvData = [
        dealMapperStore.deals,
        dealMapperStore.dealTransactions,
        dealMapperStore.dtvts,
        dealMapperStore.voucherTransactions,
        dealMapperStore.vouchers,
      ];
      //   <ZipLink data={csvData} target="_self">
      //     Export Data
      //   </ZipLink>;
      return (
        <Formik
          initialValues={{
            centricView: initialCentricity(),
          }}
          render={({ values, setFieldValue }) => (
            <div css={Drawer}>
              <div css={ButtonContainerStyle}>
                <div className="flexApartContainer">
                  <Row>
                    <SimpleSelect
                      containerStyle={{ margin: '0px' }}
                      label="Mapper View"
                      handleChange={e => {
                        dealMapperStore.dealMapperViewStore.setViewCentricity(
                          ViewCentricity[e.target.value].val,
                        );
                        setFieldValue('centricView', e.target.value);
                      }}
                      value={values.centricView}
                      name="viewCentricity"
                    >
                      {ViewCentricity.map((obj, i) => (
                        <MenuItem key={obj.type} value={i}>
                          {obj.type}
                        </MenuItem>
                      ))}
                    </SimpleSelect>
                  </Row>
                  <div className="rightButtonContainer">
                    <Button
                      style={
                        dealMapperStore.isAnythingPending
                          ? {
                              color: COLORS.blue,
                            }
                          : null
                      }
                      onClick={async () => {
                        const {
                          isValid,
                          validationErrors,
                        } = await dealMapperStore.validateObjects();
                        if (isValid) {
                          await dealMapperStore.persistState();
                          dataStore.refreshDataAfterDealMap();
                        } else {
                          setErrorList(validationErrors);
                          setShowInvalidModal(true);
                        }
                      }}
                    >
                      Save Changes
                    </Button>
                    <Button onClick={dealMapperStore.reset}>
                      Reset Changes
                    </Button>
                    <Button
                      onClick={() => console.log(dealMapperStore.clearState())}
                    >
                      Empty Mapper
                    </Button>
                    <IconButton
                      onClick={handleMenuClick}
                      style={{ marginTop: '-3px' }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                      }}
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      <span />
                      <ZipLink data={csvData} target="_self">
                        Export Data
                      </ZipLink>
                    </Menu>
                  </div>
                </div>
              </div>
              <Snackbar
                css={SnackbarStyle}
                open={showInvalidModal}
                onClose={() => setShowInvalidModal(false)}
                // autoHideDuration={8000}
                message={
                  <span id="client-snackbar">
                    <div className="generic-error-section">
                      <ErrorIcon className="errorIcon" />
                      <b> Unable to save changes due to validation errors:</b>
                    </div>
                    <div style={{ display: 'block' }}>
                      <ul>
                        {errorList.map(e => (
                          <li key={e} className="error-bullet">
                            {e}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </span>
                }
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                action={
                  <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    onClick={() => setShowInvalidModal(false)}
                  >
                    <CloseIcon />
                  </IconButton>
                }
              />
            </div>
          )}
        />
      );
    }}
  />
);

export default DealMapperDrawer;
